import React, { useState } from "react";
import ModalSendForReview from "./ModalSendForReview";

const WrapModalSend = ({ children, ...props}) => {
  const [open, setOpen] = useState(false)

  const handleOpen = () =>  {
    setOpen(true)
  }

  const handleClose = () => setOpen(false)

  return (
    <>
      {children({ onOpen: handleOpen })}
      {open && 
        <ModalSendForReview
          isOpen={open}
          toggle={handleClose}
          {...props}
          // dataEdit={dataEdit}
        >
        </ModalSendForReview>
      }
    </>
  )
}

export default WrapModalSend
